"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "aosta": {
    "2c6eea2f": [{
      "hkey": "df84fd7c",
      "slug": "corso-battaglione-aosta-via-chambery-quartiere-cogne",
      "name": "Corso Battaglione Aosta-Via Chambery-Quartiere Cogne",
      "primary": true,
      "skipSearch": false
    }],
    "saint-martin-de-corleans-via-chambery-quartiere-cogne": [{
      "hkey": "df84fd7c",
      "slug": "corso-battaglione-aosta-via-chambery-quartiere-cogne",
      "name": "Corso Battaglione Aosta-Via Chambery-Quartiere Cogne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bf18093e": [{
      "hkey": "f5cc661a",
      "slug": "collina",
      "name": "Collina",
      "primary": true,
      "skipSearch": false
    }],
    "zona-precollinare": [{
      "hkey": "f5cc661a",
      "slug": "collina",
      "name": "Collina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ec0d11b5": [{
      "hkey": "838b94ce",
      "slug": "champailler-vignole",
      "name": "Champailler-Vignole",
      "primary": true,
      "skipSearch": false
    }],
    "champailler": [{
      "hkey": "838b94ce",
      "slug": "champailler-vignole",
      "name": "Champailler-Vignole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9600df29": [{
      "hkey": "f5cc661a",
      "slug": "collina",
      "name": "Collina",
      "primary": true,
      "skipSearch": false
    }],
    "a9b3ae00": [{
      "hkey": "d6a51242",
      "slug": "arpuilles-entrebin-excenex",
      "name": "Arpuilles-Entrebin-Excenex",
      "primary": true,
      "skipSearch": false
    }],
    "entrebin": [{
      "hkey": "d6a51242",
      "slug": "arpuilles-entrebin-excenex",
      "name": "Arpuilles-Entrebin-Excenex",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6744fe6f": [{
      "hkey": "d6a51242",
      "slug": "arpuilles-entrebin-excenex",
      "name": "Arpuilles-Entrebin-Excenex",
      "primary": true,
      "skipSearch": false
    }],
    "excenex": [{
      "hkey": "d6a51242",
      "slug": "arpuilles-entrebin-excenex",
      "name": "Arpuilles-Entrebin-Excenex",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "43689005": [{
      "hkey": "d6a51242",
      "slug": "arpuilles-entrebin-excenex",
      "name": "Arpuilles-Entrebin-Excenex",
      "primary": true,
      "skipSearch": false
    }],
    "52c19f73": [{
      "hkey": "b2c13701",
      "slug": "signayes-larevoire",
      "name": "Signayes-Larevoire",
      "primary": true,
      "skipSearch": false
    }],
    "laravoire": [{
      "hkey": "b2c13701",
      "slug": "signayes-larevoire",
      "name": "Signayes-Larevoire",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "66210415": [{
      "hkey": "1f78a388",
      "slug": "beauregard-quartiere-dora",
      "name": "Beauregard-Quartiere Dora",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "1f78a388",
      "slug": "beauregard-quartiere-dora",
      "name": "Beauregard-Quartiere Dora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "arpuilles": [{
      "hkey": "d6a51242",
      "slug": "arpuilles-entrebin-excenex",
      "name": "Arpuilles-Entrebin-Excenex",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c2a4fda7": [{
      "hkey": "fbb6c27b",
      "slug": "porossan",
      "name": "Porossan",
      "primary": true,
      "skipSearch": false
    }],
    "cache": [{
      "hkey": "fbb6c27b",
      "slug": "porossan",
      "name": "Porossan",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cossan": [{
      "hkey": "f5cc661a",
      "slug": "collina",
      "name": "Collina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "539e7823": [{
      "hkey": "df84fd7c",
      "slug": "corso-battaglione-aosta-via-chambery-quartiere-cogne",
      "name": "Corso Battaglione Aosta-Via Chambery-Quartiere Cogne",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "df84fd7c",
      "slug": "corso-battaglione-aosta-via-chambery-quartiere-cogne",
      "name": "Corso Battaglione Aosta-Via Chambery-Quartiere Cogne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "899cc9f8": [{
      "hkey": "928f315d",
      "slug": "aosta",
      "name": "Aosta",
      "primary": true,
      "skipSearch": false
    }],
    "seyssinod": [{
      "hkey": "928f315d",
      "slug": "aosta",
      "name": "Aosta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4731dac5": [{
      "hkey": "b2c13701",
      "slug": "signayes-larevoire",
      "name": "Signayes-Larevoire",
      "primary": true,
      "skipSearch": false
    }],
    "signayes": [{
      "hkey": "b2c13701",
      "slug": "signayes-larevoire",
      "name": "Signayes-Larevoire",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6598d7f0": [{
      "hkey": "838b94ce",
      "slug": "champailler-vignole",
      "name": "Champailler-Vignole",
      "primary": true,
      "skipSearch": false
    }],
    "vignole": [{
      "hkey": "838b94ce",
      "slug": "champailler-vignole",
      "name": "Champailler-Vignole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6d03d133": [{
      "hkey": "f5cc661a",
      "slug": "collina",
      "name": "Collina",
      "primary": true,
      "skipSearch": false
    }],
    "zona-collinare": [{
      "hkey": "f5cc661a",
      "slug": "collina",
      "name": "Collina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;